
(() => {
  const init = (root) => {
    if (!root || root.dataset.matjaReady === 'true') return;
    const track = root.querySelector('[data-matja-track]');
    const slides = [...root.querySelectorAll('[data-matja-slide]')];
    if (!track || slides.length < 1) return;
    root.dataset.matjaReady = 'true';
    const prev = root.querySelector('[data-matja-prev]');
    const next = root.querySelector('[data-matja-next]');
    const dots = [...root.querySelectorAll('[data-matja-dot]')];
    let index = 0;
    let timer;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const delay = Math.max(3, Number(root.dataset.delay || 6)) * 1000;
    const autoplay = root.dataset.autoplay === 'true' && slides.length > 1 && !reduceMotion;
    const render = () => {
      track.style.transform = `translate3d(${-index * 100}%,0,0)`;
      slides.forEach((slide, i) => slide.setAttribute('aria-hidden', i === index ? 'false' : 'true'));
      dots.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
    };
    const move = (step) => { index = (index + step + slides.length) % slides.length; render(); restart(); };
    const restart = () => { if (!autoplay) return; clearInterval(timer); timer = setInterval(() => move(1), delay); };
    prev?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => { index = i; render(); restart(); }));
    root.addEventListener('mouseenter', () => clearInterval(timer));
    root.addEventListener('mouseleave', restart);
    root.addEventListener('focusin', () => clearInterval(timer));
    root.addEventListener('focusout', restart);
    render(); restart();
  };
  const initAll = (scope = document) => scope.querySelectorAll('[data-matja-slider]').forEach(init);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
